/**
 * Navigasyonun tek kaynağı. Sayfa eklemek: buraya bir satır — hem üst şerit
 * (masaüstü) hem alt sekme çubuğu (mobil) aynı listeden besleniyor.
 */

export type PageId = 'market' | 'trade' | 'bots' | 'pnl' | 'ledger'

export interface PageDef {
  id: PageId
  /** Üst şeritteki tam ad. */
  label: string
  /**
   * Yalnız mobil sekme çubuğunda görünür. Masaüstünde karşılığı ayrı bir sayfa
   * değil: kontrat listesi, emir defteri ve emir girişi orada zaten aynı
   * ekranda duruyor. Üst şerit bu kayıtları eliyor.
   */
  mobileOnly?: boolean
  /**
   * Alt sekme çubuğundaki kısa ad. Üç sekmeyle tam adlar da sığıyor ama kısası
   * bilerek: sekme sayısı arttıkça (Faz 2 `İşlem`, Faz 3 `Botlar`) genişlik
   * bölünecek ve etiketlerin o gün kırpılması yerine bugünden sabit durması
   * daha iyi. `Kayıt Defteri` → `Defter` DEĞİL `Kayıt`: bu alanda "defter"
   * emir defterini çağrıştırıyor.
   */
  short: string
  /**
   * 24×24 kutuya çizilen SVG yolları. Veri olarak duruyor (JSX değil) ki bu
   * dosya sade bir veri modülü kalsın; çizimi `TabBar` yapıyor. Çizgi tabanlı
   * — dolgu yok, `stroke: currentColor` (bkz. `.tabbar svg`).
   */
  icon: string[]
}

export const PAGES: PageDef[] = [
  {
    id: 'market',
    label: 'Piyasa',
    short: 'Piyasa',
    // İki mum: tahtanın kendisi. Fitiller gövdelere değiyor.
    icon: ['M8 3.5v3.5M8 17v3.5M5.5 7h5v10h-5z', 'M16 6.5v3M16 15.5v4M13.5 9.5h5v6h-5z'],
  },
  {
    id: 'trade',
    label: 'İşlem',
    short: 'İşlem',
    mobileOnly: true,
    // Zıt yönlü iki ok: alış-satış.
    icon: ['M7 4.5v13M4 7.5l3-3 3 3', 'M17 19.5v-13M14 16.5l3 3 3-3'],
  },
  {
    id: 'bots',
    label: 'Botlar',
    short: 'Botlar',
    mobileOnly: true,
    // Gövde + anten + iki göz + ağız.
    icon: ['M6 8.5h12v10H6z', 'M12 4.5v4', 'M9.5 12v1.5M14.5 12v1.5', 'M10 16h4'],
  },
  {
    id: 'pnl',
    label: 'PnL Takip',
    short: 'PnL',
    // Yükselen çizgi + sağ üstte ok başı.
    icon: ['M3.5 16.5 9 11l3.5 3.5L20.5 7', 'M15.5 7h5v5'],
  },
  {
    id: 'ledger',
    label: 'Kayıt Defteri',
    short: 'Kayıt',
    // Köşesi kıvrık sayfa + satırlar: kayıt/geçmiş.
    icon: ['M5.5 3.5h9l4 4v13h-13z', 'M14.5 3.5v4h4', 'M9 12.5h6M9 16h6'],
  },
]

/**
 * Masaüstünde karşılığı olmayan sayfalar. Pencere genişlerken bu sayfalardan
 * birindeysek boş ekranda kalmamak için `market`e düşülüyor (bkz. App.tsx).
 * Listeden türetiliyor ki yeni bir `mobileOnly` sayfa eklendiğinde burası
 * unutulmasın.
 */
export const MOBIL_SAYFALAR: ReadonlySet<PageId> = new Set(
  PAGES.filter((item) => item.mobileOnly).map((item) => item.id),
)
